import api from "../api/axios";

export async function fetchOffices() {
  const { data } = await api.get("/offices");

  const filteredOffices = (data || []).filter((office) => office.officeName !== "Desarrollo");

  return filteredOffices;
}
